import { IconEdit, IconLayoutGrid, IconList, IconPlus, IconUserCircle } from '@tabler/icons-react';

type HomepageLink = {
  id: number;
  label: string;
  href: string;
};

export const linksMenuHomepage: HomepageLink[] = [
  {
    id: 1,
    label: 'HOME',
    href: 'home',
  },
  {
    id: 2,
    label: 'EVENTOS',
    href: 'eventos',
  },
];

export type Submenu = {
  id: number;
  icon?: React.ElementType;
  label: string;
  href: string;
  adminOnly?: boolean;
  organizerOnly?: boolean;
};

/** Submenus que o papel do usuário pode ver. Usado pelo menu do desktop e pelo do celular. */
export const visibleSubmenus = (submenus: Submenu[], role: string | undefined): Submenu[] =>
  submenus
    .filter((submenu) => role === 'admin' || !submenu.adminOnly)
    .filter(
      (submenu) =>
        (role === 'admin' && !submenu.organizerOnly) ||
        (role === 'organizer' && !submenu.adminOnly) ||
        (!submenu.adminOnly && !submenu.organizerOnly)
    );

export type MenuLink = {
  id: number;
  label: string;
  href: string;
  submenu?: Submenu[];
};

export const linksMenu: MenuLink[] = [
  {
    id: 1,
    label: 'eventos',
    href: '/dashboard/evento',
    submenu: [
      {
        id: 1,
        icon: IconLayoutGrid,
        label: 'Eventos',
        href: '/dashboard/evento',
      },
      {
        id: 2,
        icon: IconList,
        label: 'Tabela dos eventos',
        href: '/dashboard/evento/tabela',
        adminOnly: true,
      },
      {
        id: 3,
        icon: IconPlus,
        label: 'Cadastrar evento',
        href: '/dashboard/evento/cadastrar',
        adminOnly: true,
      },
      {
        id: 4,
        icon: IconPlus,
        label: 'Cadastrar categoria',
        href: '/dashboard/evento/cadastrar/categoria',
        adminOnly: true,
      },
      {
        id: 5,
        icon: IconPlus,
        label: 'Cadastrar recebimento',
        href: '/dashboard/organizador/oauth',
        organizerOnly: true,
      },
    ],
  },
  {
    id: 2,
    label: 'perfil',
    href: '/dashboard/perfil',
    submenu: [
      {
        id: 1,
        icon: IconUserCircle,
        label: 'Meu perfil',
        href: '/dashboard/perfil',
      },
      {
        id: 2,
        icon: IconEdit,
        label: 'Editar perfil',
        href: '/dashboard/perfil/editar',
      },
    ],
  },
  {
    id: 3,
    label: 'equipe',
    href: '/dashboard/equipe',
    submenu: [
      {
        id: 1,
        icon: IconPlus,
        label: 'Cadastrar equipe',
        href: '/dashboard/equipe',
      },
      {
        id: 2,
        icon: IconPlus,
        label: 'Adicionar atleta',
        href: '/dashboard/equipe/atleta',
      },
    ],
  },
];
